import { QcProperties } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-device-configuration-status-tracking/settings-device-configuration-status-tracking.model';

export const QC_LEVELS = Array.from({ length: 30 }, (_, i) => i + 1);
export const QC_HOURS = Array.from({ length: 24 }, (_, i) => i + 1);
export const QC_LOCKOUT_PERIODS: QcProperties['qcType'][] = ['TIME_INTERVAL'];
